import React from 'react';
import { apiIsLoggedIn } from '../api/api';
import '../styles/timeline.css';
import TopBarMain from '../components/topbars/TopBarMain';
import ReunionTimeline from '../components/tables/ReunionPhotos/ReunionTimeline';

class TimeLinePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoggedIn: false,
        }
    }

    componentDidMount() {
        apiIsLoggedIn().then(isLoggedIn => {
            if (!isLoggedIn) {
                window.location.href = '/';
            } else {
                this.setState({ isLoggedIn: true });
            }
        });
    }

    render() {
        return (
            <div>
                <TopBarMain />
                <div className='timeline-page'>
                    <h2>Reunion Timeline</h2>
                    {this.state.isLoggedIn ? <ReunionTimeline /> : <p/>}
                    <p>More coming soon! Please email <a href="mailto:ramsey.opp@gmail.com">ramsey.opp@gmail.com</a> if you have any information to help.</p>
                </div>
            </div>
        );
    }
}

export default TimeLinePage;
